import { AssessmentQuestionType } from './assessment-question-type.enum';

export interface AttemptQuestion {
  uuid: string;
  resposta: string;
  nota: number;
  feedback: string;
  anulado: number;
  anulado_motivo: string;
  em_branco: number;
  response_card_error: string;
  alterado_por: number;
  updated_at: string;
  alternativa: { uuid: string };
  questao: { uuid: string; tipo: AssessmentQuestionType };
}
export interface AttemptProficiency {
  padrao_disciplina_id: number;
  proficiencia: number;
  coeficiente: number;
  percentual: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  padrao_disciplina: { id: number; descricao: string };
}
export interface AttemptStudent {
  usuario_id: number;
  nome: string;
  foto: string;
  habilitar_paaeb: number;
  liberar_data_inicio: string;
  liberar_data_fim: string;
  padrao_serie_id: number;
  turma_id: number;
  turma_descricao: string;
  tentativa_uuid: string;
  tentativa_file_url: string;
  tentativa_qrcode: string;
  tentativa_modo_rand: number;
  data_inicio: string;
  data_fim: string;
  nota_calculada: number;
  qtd_questoes_respondidas: number;
  qtd_acertos: number;
  status: number;
  tentativa_response_card_upload_page: number;
  tentativa_response_card_upload: any;
  necessidades_especiais: any[];
  tentativa_proficiencia: AttemptProficiency[];
  tentativa_questoes: AttemptQuestion[];
}
